/**
 * Splits the raw `TextArea` text into terms: one trimmed, non-empty line per term. The line break is
 * the only separator — a term itself may contain spaces and commas ("Résidence Les Tilleuls").
 * Shared by `toCommandData()`, `isVocabularyTermsValid` and the field's live counter, so the three
 * never risk disagreeing on what counts as a term.
 */
const splitVocabularyTerms = (rawText: string): string[] => {
	return rawText
		.split('\n')
		.map((line) => line.trim())
		.filter((line) => line.length > 0);
};

export default splitVocabularyTerms;
